import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Task } from '../../models/task.model';

export interface CreateTaskRequest {
  fieldId: number | null;
  cropId: number | null;
  type: string;
  title: string;
  status: string;
  plannedAt: string | null;
}

export type TaskAdviceReason =
  | 'after_harvest'
  | 'after_mulch'
  | 'after_lime'
  | 'after_plow'
  | 'after_cultivate'
  | 'after_sow'
  | 'after_roll'
  | 'after_fertilize'
  | 'after_weed'
  | 'no_recommendation';

export interface TaskAdvice {
  recommendedTaskType: string | null;
  availableTaskTypes: string[];
  reason: TaskAdviceReason;
}

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private readonly http = inject(HttpClient);

  getTasks(farmId?: number): Observable<Task[]> {
    let params = new HttpParams();

    if (farmId !== undefined) {
      params = params.set('farmId', farmId);
    }

    return this.http.get<Task[]>(
      `${environment.apiUrl}/tasks`,
      {
        params,
      },
    );
  }

  createTask(
    task: CreateTaskRequest,
  ): Observable<Task> {
    return this.http.post<Task>(
      `${environment.apiUrl}/tasks`,
      task,
    );
  }

  updateTaskStatus(
    taskId: number,
    status: Task['status'],
  ): Observable<Task> {
    return this.http.patch<Task>(
      `${environment.apiUrl}/tasks/${taskId}/status`,
      {
        status,
      },
    );
  }

  getTaskAdvice(
    taskId: number,
  ): Observable<TaskAdvice> {
    return this.http.get<TaskAdvice>(
      `${environment.apiUrl}/tasks/${taskId}/advice`,
    );
  }
}
